import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./Contributors.module.scss";
import { Contributor, ContributorType } from "./Contributor";
export const Contributors: React.FC<{
  title: string;
  contributors: ContributorType[];
  displayImages?: boolean;
}> = t0 => {
  const $ = _c(12);
  const {
    title,
    contributors,
    displayImages: t1
  } = t0;
  const displayImages = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== title) {
    t2 = <h4 className={styles.contributors__title}>{title}</h4>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== contributors || $[3] !== displayImages) {
    let t4;
    if ($[5] !== displayImages) {
      t4 = member => <Contributor key={member._id} displayImage={displayImages} {...member} />;
      $[5] = displayImages;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = contributors.map(t4);
    $[2] = contributors;
    $[3] = displayImages;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className={styles.contributors__list}>{t3}</div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className={styles.contributors}>{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};